import React, {useEffect, useState} from "react";
import axios from "axios";
import {toast} from "react-toastify";
import {useDispatch, useSelector} from "react-redux";
import DateHelper from "../../../primer/DateHelper/DateHelper";
import {Col, Row, Spinner} from "react-bootstrap";
import DateBox from "../../../primer/DateBox";
import {checkPermission, getGreekCurrencyFormat} from "../../../../_helpers/commonFunctions";
import moment from "moment/moment";
import Button from "react-bootstrap/Button";
import Dropdown from "../../../primer/Dropdown";
import ReportsTemplate from "../../../common/ReportsTemplate";
import AccountingBox from "../../../primer/AccountingBox";
import { setCompaniesAiUsageRequestData, setCompaniesAiUsageResponseData } from "../../../../_reducers/aiSlice";
import EditableTable from "../../../primer/Editable-Table";
import Pagination from "../../../primer/Pagination";
import Alert from "react-bootstrap/Alert";
import {useTranslation} from "../../../../hooks/useTranslation";

const ReportsCompaniesAiUsage = () => {
    const {t} = useTranslation();
    const dispatch = useDispatch();
    const requestData = useSelector((state) => state.AI.companiesAiUsageRequestData);
    const responseData = useSelector((state) => state.AI.companiesAiUsageResponseData);
    const company = useSelector((state) => state.COMPANY_DATA.company);
    const companyDetails = useSelector((state) => state.COMPANY_DATA.companyDetails);
    const [loading, setLoading] = useState(false);
    const [pageChanged, setPageChanged] = useState(false);
    const userId = JSON.parse(localStorage.getItem("user"))?._id;
    const permissionsData = JSON.parse(localStorage.getItem("permissions"));
    const [companyAccess, setCompanyAccess] = useState([]);
    const [incrKey, setIncrKey] = useState(0);

    const aiChannelOptions = [
        {label: "Όλα", value: "all"},
        {label: "Αρχεία", value: "cloudFile"},
        {label: "MyData", value: "mrId"},
        {label: "Τραπεζικές Συναλλαγές", value: "transactionId"}
    ];

    useEffect(() => {
        getCompanyAccess();
    }, []);

    useEffect(() => {
        if (pageChanged) {
            setPageChanged(false);
            fetchReport(true);
        }
    }, [pageChanged]);

    const getCompanyAccess = () => {
        axios.get(`${process.env.REACT_APP_API_URL2}/company/get-user-companies-access`, {
            headers: {"Content-Type": "application/json"},
            params: {
                userId: userId,
            }
        }).then((res) => {
            if (res.data.status === "200") {
                let acc = [];
                for (let comp of res.data.data) {
                    acc.push({label: `${comp.name} - ${comp.vatNumber}`, value: comp._id});
                }
                setCompanyAccess(acc);
                if (requestData.firstLoad === true) dispatch(setCompaniesAiUsageRequestData({...requestData, companies: [company.id], firstLoad: false}));
            }
        }).catch((err) => {
            console.log(err);
        })
    }

    const fetchReport = (fromPagination = false, customReqData = null) => {
        setLoading(true);
        let reqData = customReqData ? customReqData : { ...requestData };
        if (!fromPagination) reqData.page = 1;
        console.log(reqData)

        axios.post(`${process.env.REACT_APP_API_URL2}/ai/companies-ai-usage-report`, reqData, {
            headers: {"Content-Type": "application/json"}
        }).then((res) => {
            setLoading(false);
            if (res.status === 200) {
                if (!fromPagination) {
                    if (res.data.totalPages === 0) {
                        toast.info("Δεν βρέθηκαν αποτελέσματα.");
                    } else {
                        toast.success("Τα δεδομένα ανανεώθηκαν.", {autoClose: 1000});
                    }
                    dispatch(setCompaniesAiUsageRequestData({...requestData, page: 1}));
                }
                const formattedData = res.data.data.map((item, index) => ({
                    ...item,
                    no: String((index + 1) + ((reqData.page - 1) * 20)),
                    geminiCost: getGreekCurrencyFormat(item.geminiCost),
                    primerCost: getGreekCurrencyFormat(item.primerCost),
                }));
                dispatch(setCompaniesAiUsageResponseData({
                    data: formattedData,
                    totalPages: res.data.totalPages || 0,
                    ...res.data.totals,
                    creditConversion: res.data.creditConversion,
                }));
                setIncrKey(incrKey + 1);
            } else {
                toast.error(res.data.message);
            }
        }).catch((error) => {
            setLoading(false);
            console.log(error);
            toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
        })
    }

    const columns = [
        {
            name: "Αρ.",
            field: "no",
            editable: false,
            inputType: { type: "text" },
        },
        {
            name: "Όνομα Εταιρείας",
            field: "companyName",
            editable: false,
            inputType: { type: "text" }
        },
        {
            name: "ΑΦΜ Εταιρείας",
            field: "companyVatNumber",
            editable: false,
            inputType: { type: "text" }
        },
        {
            name: "AI Credits Files",
            field: "aiTokensFiles",
            editable: false,
            inputType: { type: "text" }
        },
        {
            name: "AI Credits myDATA Report",
            field: "aiTokensMyData",
            editable: false,
            inputType: { type: "text" }
        },
        {
            name: "AI Credits Τραπεζικών",
            field: "aiTokensBank",
            editable: false,
            inputType: { type: "text" }
        },
        {
            name: "AI Credits",
            field: "aiTokens",
            editable: false,
            inputType: { type: "text" }
        },
        {
            name: "Αρ. παρ. αρχείων",
            field: "filesCount",
            editable: false,
            inputType: { type: "text" }
        },
        {
            name: "Αρ. παρ. myDATA",
            field: "myDataCount",
            editable: false,
            inputType: { type: "text" }
        },
        {
            name: "Αρ. Τραπεζικών Συναλ.",
            field: "bankCount",
            editable: false,
            inputType: { type: "text" }
        },
        {
            name: "Σύνολο εγγραφών",
            field: "totalDocumentCount",
            editable: false,
            inputType: { type: "text" }
        },
        {
            name: "Κόστος Gemini",
            field: "geminiCost",
            editable: false,
            inputType: { type: "text" }
        },
        {
            name: "Κόστος Primer",
            field: "primerCost",
            editable: false,
            inputType: { type: "text" }
        },
        {
            name: "Κόστος ανά Παραστατικό Gemini / Primer",
            field: "customField",
            editable: true,
            inputType: {
                type: "custom-render",
                render: (rowData) => {
                    const xMult = +(rowData.perDocumentPrimerCost / rowData.perDocumentGeminiCost);

                    return <span>
                        {getGreekCurrencyFormat(rowData.perDocumentGeminiCost, 4)} / {getGreekCurrencyFormat(rowData.perDocumentPrimerCost, 4)}{" "}
                        (<u>{isFinite(xMult) ? `${xMult.toFixed(1)}x` : "-"}</u>)
                    </span>
                }
            }
        }
    ];

    const handleOnChange = (e, type, name) => {
        let prepChange = {};
        if (type === "msdd") {
            prepChange[name] = e.flatMap((o) => o.value);
        } else if (type === "datebox") {
            if (moment(e).isValid()) {
                prepChange[name] = moment(e).format("DD/MM/YYYY");
            } else {
                prepChange[name] = "";
            }
        } else if (type === "input") {
            prepChange[name] = +e.target.value || 0;
        } else if (type === "dropdown") {
            prepChange[name] = e.value;
        }
        dispatch(setCompaniesAiUsageRequestData({...requestData, ...prepChange}));
    }

    const handleChangeSortMethod = (e, field) => {
        const currentField = requestData.sortOptions?.sortField;
        const currentMethod = requestData.sortOptions?.sortMethod;

        let newMethod = "ASC";

        if (currentField === field) {
            if (currentMethod === "ASC") {
                newMethod = "DESC";
            } else if (currentMethod === "DESC") {
                newMethod = null;
            }
        }

        const newSortOptions = newMethod ? {
            sortField: field,
            sortMethod: newMethod
        } : {};

        const updatedRequest = {
            ...requestData,
            sortOptions: newSortOptions
        };

        dispatch(setCompaniesAiUsageRequestData(updatedRequest));
        fetchReport(true, updatedRequest);
    }

    const onPageChange = (newPage) => {
        const updatedRequest = { ...requestData, page: newPage };
        dispatch(setCompaniesAiUsageRequestData(updatedRequest));
        fetchReport(true, updatedRequest);
    }

    const thickBorderStyle = "2px solid #76aeb7";

    return (
        <div>
            <ReportsTemplate templateType={"reports-companies-ai-usage"} requestData={requestData} fetchReport={() => fetchReport()} setRequestData={(data) => dispatch(setCompaniesAiUsageRequestData(data))} header={"Στατιστικά Χρήσης AI ανά Εταιρεία"}/>
            <Row className="mb-2">
                <Col sm={12} md={2}>
                    <DateHelper
                        dateFromAndToFunction={(from, to) => {
                            dispatch(setCompaniesAiUsageRequestData({...requestData, date_from: from, date_to: to}));
                        }}
                    />
                </Col>
                <Col sm={6} md={2}>
                    <DateBox
                        name={"date_from"}
                        label={"Ημερομηνία από"}
                        selected={moment(requestData.date_from, "DD/MM/YYYY").isValid() ? moment(requestData.date_from, "DD/MM/YYYY").toDate() : ""}
                        onChange={(e) => handleOnChange(e, "datebox", "date_from")}
                        allowOtherYears={true}
                    />
                </Col>
                <Col sm={6} md={2}>
                    <DateBox
                        name={"date_to"}
                        label={"Ημερομηνία μέχρι"}
                        selected={moment(requestData.date_to, "DD/MM/YYYY").isValid() ? moment(requestData.date_to, "DD/MM/YYYY").toDate() : ""}
                        onChange={(e) => handleOnChange(e, "datebox", "date_to")}
                        allowOtherYears={true}
                    />
                </Col>
                <Col sm={12} md={4}>
                    <Dropdown
                        name={"companies"}
                        label={"Εταιρείες"}
                        placeholder={"Επιλογή με Όνομα ή ΑΦΜ"}
                        multiSelect={true}
                        options={companyAccess}
                        key={Math.random()}
                        defaultValue={companyAccess.filter((el) => requestData.companies.includes(el.value))}
                        onChange={(e) => handleOnChange(e, "msdd", "companies")}
                    />
                </Col>
                <Col sm={12} md={2}>
                    <Dropdown
                        name={"aiChannel"}
                        label={"Κανάλι AI"}
                        options={aiChannelOptions}
                        key={Math.random()}
                        defaultValue={aiChannelOptions.find(opt => opt.value === requestData.aiChannel)}
                        onChange={(e) => handleOnChange(e, "dropdown", "aiChannel")}
                    />
                </Col>
            </Row>
            <Row className="mb-2">
                <Col sm={12} md={2}>
                    <label htmlFor="geminiCostFrom">{"Κόστος Gemini Από"}</label>
                    <AccountingBox
                        name={"geminiCostFrom"}
                        placeholder={"Κόστος Gemini Από"}
                        type={"number"}
                        defaultValue={requestData.geminiCostFrom}
                        onBlur={(e) => handleOnChange(e, "input", "geminiCostFrom")}
                    />
                </Col>
                <Col sm={12} md={2}>
                    <label htmlFor="geminiCostTo">{"Κόστος Gemini Έως"}</label>
                    <AccountingBox
                        name={"geminiCostTo"}
                        placeholder={"Κόστος Gemini Έως"}
                        type={"number"}
                        defaultValue={requestData.geminiCostTo}
                        onBlur={(e) => handleOnChange(e, "input", "geminiCostTo")}
                    />
                </Col>
                <Col sm={12} md={2}>
                    <label htmlFor="primerCostFrom">{"Κόστος Primer Από"}</label>
                    <AccountingBox
                        name={"primerCostFrom"}
                        placeholder={"Κόστος Gemini Από"}
                        type={"number"}
                        defaultValue={requestData.primerCostFrom}
                        onBlur={(e) => handleOnChange(e, "input", "primerCostFrom")}
                    />
                </Col>
                <Col sm={12} md={2}>
                    <label htmlFor="primerCostTo">{"Κόστος Primer Έως"}</label>
                    <AccountingBox
                        name={"primerCostTo"}
                        placeholder={"Κόστος Gemini Έως"}
                        type={"number"}
                        defaultValue={requestData.primerCostTo}
                        onBlur={(e) => handleOnChange(e, "input", "primerCostTo")}
                    />
                </Col>
                <Col sm={12} md={2}>
                    <label htmlFor="creditConversion">{"Κόστος € ανά credit"}</label>
                    <AccountingBox
                        name={"creditConversion"}
                        placeholder={"Κόστος € ανά credit"}
                        decimalLimit={5}
                        type={"number"}
                        defaultValue={requestData.creditConversion}
                        onBlur={(e) => handleOnChange(e, "input", "creditConversion")}
                    />
                </Col>
            </Row>
            {checkPermission("custom-admin" && permissionsData) && (
                <Row className={"mb-2"}>
                    <Col md={12} className={"ml-auto"}>
                        <Button onClick={() => fetchReport()} className="btn btn-primary float-right"
                                disabled={loading}>
                            {t('General.applyFilter')}
                            {loading && <Spinner className={"ml-2"} animation={"border"} variant={"dark"}/>}
                        </Button>
                    </Col>
                </Row>
            )}
            {responseData.totalPages > 0 && (
                <div>
                    <hr/>
                    <Row>
                        <Col md={7}>
                            {responseData.creditConversion !== 0.013 && (
                                <Alert variant={"danger"}>
                                    <strong>Προσοχή!</strong> Η αξία συναλλάγματος € / credit έχει τροποποιηθεί και η αξίες δεν συμφωνούν με την πραγματικότητα!
                                </Alert>
                            )}
                        </Col>
                        <Col md={5} className={"d-flex justify-content-end"}>
                            <Pagination
                                currentPage={requestData.page}
                                totalPages={responseData.totalPages}
                                handlePageChange={onPageChange}
                                maxWidth={400}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12}>
                            <EditableTable
                                key={"Companies AI usage report" + incrKey}
                                tableName="Companies AI usage report"
                                data={responseData.data}
                                allowPagination={false}
                                allowToggleColumns={true}
                                allowInsertRow={false}
                                editRedirectAllowed={true}
                                enableNewRowCheckbox={false}
                                allowBulkActions={true}
                                reportExcelPrint={true}
                                pageTotals={false}
                                company={company}
                                companyDetails={companyDetails}
                                columns={columns}
                                allowActions={false}
                                allowPrintResults={checkPermission("custom-admin" && permissionsData) === true}
                                allowSorting={true}
                                sortOptions={{ "Companies AI usage report" : requestData.sortOptions }}
                                handleChangeSortMethod={handleChangeSortMethod}
                                filters={requestData}
                            />
                        </Col>
                    </Row>
                    <Row className={"d-flex justify-content-end mb-3"}>
                        <Col md={4} className={"d-flex justify-content-end"}>
                            <table className={"simpleClassicTable"}>
                                <tbody>
                                <tr style={{borderTop: thickBorderStyle, borderRight: thickBorderStyle, borderLeft: thickBorderStyle}}>
                                    <td className="fw-bold">Συνολικά AI Credits Αρχείων</td>
                                    <td>{responseData.totalAiTokensFiles}</td>
                                </tr>
                                <tr style={{borderRight: thickBorderStyle, borderLeft: thickBorderStyle}}>
                                    <td className="fw-bold">Συνολικά AI Credits myDATA</td>
                                    <td>{responseData.totalAiTokensMyData}</td>
                                </tr>
                                <tr style={{borderRight: thickBorderStyle, borderLeft: thickBorderStyle}}>
                                    <td className="fw-bold">Συνολικά AI Credits Τραπεζικών Συναλλαγών</td>
                                    <td>{responseData.totalAiTokensBank}</td>
                                </tr>
                                <tr style={{borderBottom: thickBorderStyle, borderRight: thickBorderStyle, borderLeft: thickBorderStyle}}>
                                    <td className="fw-bold">Συνολικά AI Credits</td>
                                    <td>{responseData.totalAiTokens}</td>
                                </tr>
                                <tr style={{borderRight: thickBorderStyle, borderLeft: thickBorderStyle}}>
                                    <td className="fw-bold">Σύνολο Παραστατικών Αρχείων</td>
                                    <td>{responseData.totalFilesCount}</td>
                                </tr>
                                <tr style={{borderRight: thickBorderStyle, borderLeft: thickBorderStyle}}>
                                    <td className="fw-bold">Σύνολο Παραστατικών myDATA</td>
                                    <td>{responseData.totalMyDataCount}</td>
                                </tr>
                                <tr style={{borderRight: thickBorderStyle, borderLeft: thickBorderStyle}}>
                                    <td className="fw-bold">Σύνολο Τραπεζικών Συναλλαγών</td>
                                    <td>{responseData.totalBankCount}</td>
                                </tr>
                                <tr style={{borderBottom: thickBorderStyle, borderRight: thickBorderStyle, borderLeft: thickBorderStyle}}>
                                    <td className="fw-bold">Συνολικά Παραστατικά</td>
                                    <td>{responseData.totalDocumentCount}</td>
                                </tr>
                                <tr style={{borderRight: thickBorderStyle, borderLeft: thickBorderStyle}}>
                                    <td className="fw-bold">Συνολικό Κόστος Gemini</td>
                                    <td>{getGreekCurrencyFormat(responseData.totalGeminiCost)}</td>
                                </tr>
                                <tr style={{borderBottom: thickBorderStyle, borderRight: thickBorderStyle, borderLeft: thickBorderStyle}}>
                                    <td className="fw-bold">Συνολικό Κόστος Primer</td>
                                    <td>{getGreekCurrencyFormat(responseData.totalPrimerCost)}</td>
                                </tr>
                                <tr style={{borderRight: thickBorderStyle, borderLeft: thickBorderStyle}}>
                                    <td className="fw-bold">Κόστος ανά παραστατικό Gemini</td>
                                    <td>{getGreekCurrencyFormat(responseData.totalGeminiCost / responseData.totalDocumentCount, 4)}</td>
                                </tr>
                                <tr style={{borderRight: thickBorderStyle, borderLeft: thickBorderStyle}}>
                                    <td className="fw-bold">Κόστος ανά παραστατικό Primer</td>
                                    <td>{getGreekCurrencyFormat(responseData.totalPrimerCost / responseData.totalDocumentCount, 4)}</td>
                                </tr>
                                <tr style={{borderBottom: thickBorderStyle, borderRight: thickBorderStyle, borderLeft: thickBorderStyle}}>
                                    <td className="fw-bold">Πολλαπλασιαστής (x)</td>
                                    <td>{+Number(responseData.totalPrimerCost / responseData.totalGeminiCost).toFixed(1)}</td>
                                </tr>
                                </tbody>
                            </table>
                        </Col>
                    </Row>
                </div>
            )}
        </div>
    );
}

export default ReportsCompaniesAiUsage;